import React, { useState, useEffect, useRef } from "react";
import useWindowSize from "../../helpers/useWindowSize";

import Nav from "./Nav";
import { HiOutlineMenuAlt3, HiOutlineX } from "react-icons/hi";
import "./Header.scss";
import gsap from "gsap";
import Toggler from "../Toggler";

const Header = () => {
  //handle menu open/close for mobile size screens
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const size = useWindowSize();

  useEffect(() => {
    if (size.width >= 767 && isMenuOpen) {
      setIsMenuOpen(false);
    }
  }, [size, isMenuOpen]);

  // useEffect(() => {
  //   isMenuOpen
  //     ? (document.body.style.overflow = "hidden")
  //     : (document.body.style.overflow = "auto");
  // }, [isMenuOpen]);

  const handleMenuToggle = () => {
    setIsMenuOpen((prevState) => !prevState);
  };

  const menuToggle = !isMenuOpen ? (
    <HiOutlineMenuAlt3 onClick={handleMenuToggle} />
  ) : (
    <HiOutlineX onClick={handleMenuToggle} />
  );

  //show/hide the navbar
  const [show, setShow] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const controlNavbar = () => {
      if (
        typeof window !== "undefined" &&
        window.pageYOffset > lastScrollY &&
        window.innerWidth >= 767
      ) {
        setShow(false);
      } else {
        setShow(true);
      }
      setLastScrollY(window.pageYOffset);
    };

    window.addEventListener("scroll", controlNavbar);
    return () => {
      window.removeEventListener("scroll", controlNavbar);
    };
  }, [lastScrollY]);

  //header elements animations
  const headerContentRef = useRef([]);
  headerContentRef.current = [];

  useEffect(() => {
    // console.log(headerContentRef.current)
    headerContentRef.current.forEach((element) => {
      gsap.from(element, {
        y: -100,
        duration: 1.1,
        ease: "power3.out",
        delay: 1.2,
      });
    });
  }, []);

  const addToRefs = (el) => {
    headerContentRef.current.push(el);
  };

  return (
    <header className={`header ${show ? "" : "hidden"}`}>
      <div className="header-wrapper" ref={addToRefs}>
        <span className="logo-wrapper">
          <span className="logo">
            <p>
              MURAD <br />
              MUQBEL.
            </p>
          </span>
        </span>
        <div className="container">
          <div className="mobile-toggler">
            <Toggler />
          </div>
          <div className="nav-wrapper">
            <Nav />
            <div className="mobile-menu">
              <div className="mobile-menu-toggle">{menuToggle}</div>
              <div className={`menu ${isMenuOpen && "show"}`}>
                <Nav isMenuOpen={isMenuOpen} menuToggle={handleMenuToggle} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
